import _classCallCheck from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module editor-classic/classiceditoruiview
 */
import BoxedEditorUIView from '@ckeditor/ckeditor5-ui/src/editorui/boxed/boxededitoruiview';
import InlineEditableUIView from '@ckeditor/ckeditor5-ui/src/editableui/inline/inlineeditableuiview';
import StickyPanelView from '@ckeditor/ckeditor5-ui/src/panel/sticky/stickypanelview';
import ToolbarView from '@ckeditor/ckeditor5-ui/src/toolbar/toolbarview';
import '../theme/classiceditor.css';
/**
 * Classic editor UI view. Uses an inline editable and a sticky toolbar, all
 * enclosed in a boxed UI view.
 *
 * @extends module:ui/editorui/boxed/boxededitoruiview~BoxedEditorUIView
 */

var ClassicEditorUIView = /*#__PURE__*/function (_BoxedEditorUIView) {
  _inherits(ClassicEditorUIView, _BoxedEditorUIView);

  var _super = _createSuper(ClassicEditorUIView);

  /**
   * Creates an instance of the classic editor UI view.
   *
   * @param {module:utils/locale~Locale} locale The {@link module:core/editor/editor~Editor#locale} instance.
   * @param {module:engine/view/view~View} editingView The editing view instance this view is related to.
   * @param {Object} [options={}] Configuration options fo the view instance.
   * @param {Boolean} [options.shouldToolbarGroupWhenFull] When set `true` enables automatic items grouping
   * in the main {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#toolbar toolbar}.
   * See {@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull} to learn more.
   */
  function ClassicEditorUIView(locale, editingView) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, ClassicEditorUIView);

    _this = _super.call(this, locale);
    /**
     * Sticky panel view instance. This is a parent view of a {@link #toolbar}
     * that makes toolbar sticky.
     *
     * @readonly
     * @member {module:ui/panel/sticky/stickypanelview~StickyPanelView}
     */

    _this.stickyPanel = new StickyPanelView(locale);
    /**
     * Toolbar view instance.
     *
     * @readonly
     * @member {module:ui/toolbar/toolbarview~ToolbarView}
     */

    _this.toolbar = new ToolbarView(locale, {
      shouldGroupWhenFull: options.shouldToolbarGroupWhenFull
    });
    /**
     * Editable UI view.
     *
     * @readonly
     * @member {module:ui/editableui/inline/inlineeditableuiview~InlineEditableUIView}
     */

    _this.editable = new InlineEditableUIView(locale, editingView);
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ClassicEditorUIView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(ClassicEditorUIView.prototype), "render", this).call(this); // Set toolbar as a child of a stickyPanel and makes toolbar sticky.


      this.stickyPanel.content.add(this.toolbar);
      this.top.add(this.stickyPanel);
      this.main.add(this.editable);
    }
  }]);

  return ClassicEditorUIView;
}(BoxedEditorUIView);

export { ClassicEditorUIView as default };